<template>
  <div>
    <base-button block type="info" class="m-0" @click="modal = true">
      <i class="tim-icons icon-pencil pr-2"/> {{ $t('distributors.edit.btnLabel') }}
    </base-button>

    <modal id="CreateDistributor"
           :show.sync="modal"
           modal-classes="modal-dialog-centered modal-lg"
           showClose @close="resetForm()">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t('distributors.edit.titleText') }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-4">
          <small>{{ $t('distributors.edit.helpText') }}</small>
        </div>
        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>
        <form role="form" @submit.prevent="validate()">
          <div class="row">
            <label class="col-sm-4 col-form-label">{{ $t('generic.status') }}</label>
            <div class="col-sm-8">
              <base-input
                type="string"
                name="status"
                :value="formDetails.status"
                disabled
              >
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-4 col-form-label">{{ $t('distributors.details.type') }}</label>
            <div class="col-sm-8">
              <base-input
                type="string"
                name="status"
                :value="formDetails.type"
                disabled
              >
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-4 col-form-label">{{ $t('distributors.details.company_name') }}</label>
            <div class="col-sm-8">
              <base-input
                type="string"
                name="company_name"
                v-validate="modelValidations.required"
                :error="getError('company_name')"
                v-model="formDetails.company_name"
              >
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-4 col-form-label">{{ $t('distributors.details.email') }}</label>
            <div class="col-sm-8">
              <base-input
                type="email"
                name="email"
                v-validate="modelValidations.email"
                :error="getError('email')"
                v-model="formDetails.email"
              >
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-4 col-form-label">{{ $t('distributors.details.contact_number') }}</label>
            <div class="col-sm-8">
              <base-input
                type="string"
                name="contact_number"
                v-validate="modelValidations.required"
                :error="getError('contact_number')"
                v-model="formDetails.contact_number"
              >
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-4 col-form-label">{{ $t('distributors.details.cidrs') }}</label>
            <div class="col-sm-8">
              <div class="form-group">
                <tags-input v-model="formDetails.cidrs"
                            :input-placeholder="$t('distributors.form.cidrPlaceholder')"
                            input-size="" tag-size="medium"></tags-input>
              </div>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-4 col-form-label">{{ $t('distributors.details.client_access_status') }}</label>
            <div class="col-sm-8 form-group">
              <el-select
                class="select-primary"
                size="large"
                name="role"
                v-model="formDetails.client_access_status"
              >
                <el-option
                  v-for="option in distributorClientStatuses"
                  class="select-primary"
                  :value="option"
                  :label="$t(`clientAccessStatuses.${option}`)"
                  :key="option"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="text-center">
            <base-button
              type="info"
              class="my-4"
              @click="validate()"
              :loading="updating"
            >{{ $t('distributors.edit.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
import {BaseAlert, Modal, TagsInput} from 'src/components';
import {DatePicker, Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";

export default {
  name: 'editDistributor',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [DatePicker.name]: DatePicker,
    Modal,
    BaseAlert,
    TagsInput
  },
  props: {
    enabled: {
      type: Boolean,
      required: false,
    },
    currentDetails: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      modal: false,
      alert: false,
      formDetails: {
        company_name: this.currentDetails ? this.currentDetails.company_name : '',
        contact_number: this.currentDetails ? this.currentDetails.contact_number : '',
        type: this.currentDetails ? this.currentDetails.type : '',
        email: this.currentDetails ? this.currentDetails.email : '',
        cidrs: this.currentDetails ? this.currentDetails.cidrs : ["0.0.0.0/0", "0::0/0"],
        client_access_status: this.currentDetails ? this.currentDetails.client_access_status : 'allow',
        status: this.currentDetails ? this.currentDetails.status : "ok",
      },
      modelValidations: {
        required: {
          required: true
        },
        number: {
          numeric: true
        },
      }
    }
  },
  computed: {
    ...mapState({
      loading: state => state.distributors.loading,
      updating: state => state.distributors.updating,
      error: state => state.distributors.error,
      single: state => state.distributors.single,
      distributorTypes: state => state.distributors.distributorTypes,
      distributorClientStatuses: state => state.distributors.distributorClientStatuses,
    }),
    getActionErrorDetails() {
      return this.error ? this.error.bodyText : null;
    },
  }, methods: {
    ...mapActions(['UpdateDistributor']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.update()
        }
      });
    },
    update: function () {
      let payload = {
        id: this.currentDetails.id,
        data: {
          company_name: this.formDetails.company_name,
          contact_number: this.formDetails.contact_number,
          email: this.formDetails.email,
          cidrs: this.formDetails.cidrs,
          client_access_status: this.formDetails.client_access_status,
          status: this.formDetails.status,
        }
      }
      this.UpdateDistributor(payload).then(() => {
        if (this.error != null) {
          this.alert = true
          // got error, don't reset form
        } else {
          this.$notify({
            type: 'success',
            message: this.$t('distributors.edit.successNotification', payload.data),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.resetForm()
        }
      });
    },
    resetForm: function () {
      this.modal = false;
      this.alert = false;
      // resetting form
      this.formDetails = {
        company_name: this.currentDetails ? this.currentDetails.company_name : '',
        contact_number: this.currentDetails ? this.currentDetails.contact_number : '',
        type: this.currentDetails ? this.currentDetails.type : '',
        email: this.currentDetails ? this.currentDetails.email : '',
        cidrs: this.currentDetails ? this.currentDetails.cidrs : ["0.0.0.0/0", "0::0/0"],
        client_access_status: this.currentDetails ? this.currentDetails.client_access_status : 'allow',
        status: this.currentDetails ? this.currentDetails.status : "ok",
      }
      // reset validation errors
      this.$validator.reset()

    },
  },
  mounted() {
  },
}
</script>
